import React, { FC, useCallback } from 'react';
import { useAnalytics, AnalyticsAction } from '../../../hooks/useAnalytics';
import { OptionField, OptionFieldProps } from './OptionField';

export interface OptionFieldWithAnalyticsProps extends OptionFieldProps {
  eventAction: AnalyticsAction;
}

export const OptionFieldWithAnalytics: FC<OptionFieldWithAnalyticsProps> = ({ label, optionPath, onChange, eventAction, isDisabled }) => {
  const analytics = useAnalytics();

  const onChangeWithAnalytics = useCallback(
    (newState: boolean) => {
      analytics(eventAction, `${newState ? 'enable' : 'disable'} ${label}`);
      onChange?.(newState);
    },
    [analytics, eventAction, label, onChange]
  );

  return <OptionField label={label} optionPath={optionPath} onChange={onChangeWithAnalytics} isDisabled={isDisabled} />;
};
